/**
 * Where short links live. In dev we point at the local redirect Worker;
 * in production this is the public adhc.to host.
 */
export const REDIRECT_BASE_URL =
  (import.meta.env.VITE_REDIRECT_BASE_URL as string | undefined) ??
  (import.meta.env.DEV ? 'http://localhost:8788' : 'https://adhc.to');

export function shortUrlFor(slug: string): string {
  return `${REDIRECT_BASE_URL}/${slug}`;
}

/**
 * Public Turnstile site key. Safe to ship in the SPA bundle — it's how
 * Cloudflare identifies which widget config to load. Pair it with the secret
 * (bound on the Worker) for the verify step.
 *
 * Tests (and any future staging env) can override via VITE_TURNSTILE_SITE_KEY.
 * Set it to the always-passes test key `1x00000000000000000000AA` to avoid
 * depending on Cloudflare's challenge service in CI.
 */
export const TURNSTILE_SITE_KEY =
  (import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined) ??
  '0x4AAAAAADgshMU7us4niz3N';
